import classes from "./MoreButton.module.css";

export type MoreButtonProps = {
    /**
     * More button's text.
     * If undefined, there will be no 'more' button.
     * @author Kacper Faber
     * @since 0.1.9
    */
    moreButton?: string;

    /**
     * Optional onClick function for MoreButton
     * @author Kacper Faber
     * @since 0.1.9
    */
    onMoreButtonClick?: () => void;
};

/**
 * More button
 * @author Kacper Faber
 * @since 0.1.9
*/
function MoreButton(props: MoreButtonProps) {
    return (
        <div className={classes.root} onClick={props.onMoreButtonClick}>
            <div className={classes.content}>
                 <div className={classes.text}>
                     { props.moreButton }
                 </div>
            </div>
        </div>
    );
}

export default MoreButton;